import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchProductEntitlementsForCurrentUser} from '../../../actions/usageStatus.actions';
import moment from 'moment';
import 'moment-duration-format';
import {PageSubTitle, Table} from '../../Common/PageComponents';
import {convertTimeCreditToPcBangPoint, convertTimeCreditToTimeFormat} from '../../../util/timeUtils';

const stateToProps = state => {
  return {
    productEntitlements: state.usageStatus.productEntitlements,
  };
};

class ProductEntitlementOverview extends Component {
  componentDidMount() {
    this.props.dispatch(fetchProductEntitlementsForCurrentUser());
  }

  _renderProductEntitlements(productEntitlements) {
    productEntitlements = productEntitlements.filter(productEntitlement => productEntitlement.remainingTimeCredit > 0);
    if (productEntitlements.length === 0) {
      return (
        <tr>
          <td colSpan="5">사용중인 상품이 없습니다.</td>
        </tr>
      );
    }

    return productEntitlements
      .sort((a, b) => moment(b.purchaseDate) - moment(a.purchaseDate))
      .map((entitlement, index) => (
        <tr key={entitlement.entitlementId}>
          <td title={entitlement.entitlementId}>{productEntitlements.length - index}</td>
          <td>{entitlement.name}</td>
          <td>{convertTimeCreditToPcBangPoint(entitlement.totalTimeCredit)}</td>
          <td>{convertTimeCreditToPcBangPoint(entitlement.remainingTimeCredit)}</td>
          <td>{convertTimeCreditToTimeFormat(entitlement.remainingTimeCredit)}</td>
        </tr>
      ));
  }

  render() {
    let productEntitlements = this.props.productEntitlements;
    return (
      <div>
        <PageSubTitle title="상품요약" />
        <Table>
          <colgroup>
            <col style={{width: '65px'}} />
            <col style={{width: '120px'}} />
            <col style={{width: '90px'}} />
            <col style={{width: '100px'}} />
            <col style={{width: '100px'}} />
          </colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>구매 상품명</th>
              <th>구매 포인트</th>
              <th>사용 가능 포인트</th>
              <th className="end">사용가능시간(LOL 기준)</th>
            </tr>
          </thead>
          <tbody>{this._renderProductEntitlements(productEntitlements)}</tbody>
        </Table>
      </div>
    );
  }
}

export default connect(stateToProps)(ProductEntitlementOverview);
